import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from '../../components/form';
import { getImagePath } from '../../utils';

const rejectedSVG = getImagePath('ic_rejected.svg');

export const SubscriptionRejectedModal = ({
  open,
  onToggle: handleToggle
}) => (
  <Modal
    className="crm-modal"
    isOpen={open}
    toggle={handleToggle}
    fade={false}
    centered
  >
    <ModalBody>
      <div className="PaymentStatus">
        <div className="PaymentStatus__main">
          <img
            className="PaymentStatus__img"
            src={rejectedSVG}
            alt="modal payment status"
          />

          <span className="PaymentStatus__title PaymentStatus--muted">
            <FormattedMessage
              id="PaymentStatus.subscription.messages.rejected.title"
            />
          </span>

          <span className="PaymentStatus__subtitle PaymentStatus--muted">
            <FormattedMessage
              id="PaymentStatus.subscription.messages.rejected.body"
            />
          </span>

          <Button className="forms-Button" type="button" onClick={handleToggle}>
            <FormattedMessage
              id="PaymentStatus.subscription.buttons.rejected.submit"
            />
          </Button>
        </div>
      </div>
    </ModalBody>
  </Modal>
);

SubscriptionRejectedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

